/**
 * @file 无号码客服落地页
 * @author hukeke01
 */
import React from 'react';
import ContactItem from '../../../../components/ContactItem';
import {IData} from '../../../feedback/noNumFeedback';
import {recordProxy} from '../../../../util';

import iconWarn from '../../imgs/warn-icon-16.svg';
import iconWechat from '../../imgs/pc-icon-weixin.svg';
import iconWeibo from '../../imgs/pc-icon-weibo.svg';
import './style.less';

interface INoNumData extends IData {
    title: string;
}
interface ILocation {
    segmenttip: string;
}
interface INoNumCustomeProps {
    data: {
        customer: INoNumData[];
        location: ILocation;
    };
    search?: string;
    alaType?: string;
}
export default function NoNumCustom(props: INoNumCustomeProps) {
    const {data, search, alaType} = props;
    const {website, business_email, customer, wechat, microblog, title} = data?.customer?.[0] || {};
    const {segmenttip} = data?.location || {};
    const jump = (url, type, value) => {
        recordProxy('nuNumCustom', 'jump', JSON.stringify({type, value, title}));
        const node = document.createElement('a');
        node.setAttribute('target', '_blank');
        node.setAttribute('href', url);
        node.click();
    };
    const copyCallback = (type: string, copyText: string) => {
        const param = {
            title,
            type,
            copyText
        };
        recordProxy('noNumCustom', 'click', JSON.stringify(param));
    };
    const handleWebsiteDisplay = (website) => {
        if (website.indexOf('https') !== -1) {
            return website.split('https://')[1];
        }
        if (website.indexOf('http') !== -1) {
            return website.split('http://')[1];
        }
        return website;
    };
    const handleWebsiteLink = (website) => {
        if (website.indexOf('https') !== -1 || website.indexOf('http') !== -1) {
            return website;
        } else {
            return 'http://' + website;
        }
    };
    return (<div className="comp-no-num-custom">
        <div>
            <div className="page-title">{alaType === 'segment' ? `${search}号段查询` : title}</div>
            {alaType !== 'segment' && <div className="page-tip">
                <img className="icon-warn" src={iconWarn} />
                该主体未公布官方电话。互联网上的号码存在风险，请您注意分辨，避免上当受骗。
            </div>}
            {website && <div className="comp-web-url">
                <span>官方网站：</span>
                <span
                    className="web-url"
                    onClick={() => {jump(handleWebsiteLink(website), 'website', '企业官网');}}>
                    {handleWebsiteDisplay(website)}
                </span>
            </div>}
            {segmenttip && <div className="page-tip">
                <div>{segmenttip}</div>
                <div>陌生来电涉及转账、验证码、个人信息时，请谨慎核实。</div>
            </div>}
        </div>
        {business_email && business_email.length > 0
            && <div className="comp-part">
                <div className="comp-title">邮箱</div>
                <div className="item-wrap">
                    {business_email.map(item => {
                        return <ContactItem
                            key={item.add}
                            contactName={item.name}
                            contactSubtext={item.add}
                            copyText={item.add}
                            copyCallback={() => copyCallback('businessEmail-copy', item.add)}
                        />;
                    })}
                </div>
            </div>}
        {customer && customer.length > 0
            && <div className="comp-part">
                <div className="comp-title">在线客服</div>
                <div className="item-wrap">
                    {customer.map((item, index) => {
                        return <div
                            key={index}
                            className="web-url online-url"
                            onClick={() => {jump(item.url, 'customer', item.name);}}
                        >
                            {item.name}
                        </div>;
                    })}
                </div>
            </div>}
        {(wechat || microblog) && <div className="comp-part">
            <div className="comp-title">其他联系方式</div>
            <div className="item-wrap">
                {wechat && wechat.length > 0
                    && wechat.map(item => {
                        return <ContactItem
                            key={item.id}
                            contactIcon={iconWechat}
                            contactName={item.name}
                            contactSubtext={item.id}
                            copyText={item.id}
                            copyCallback={() => copyCallback('wechat-copy', item.id)}
                            picQrCode={item.qrcodeUrl}
                        />;
                    })}
                {microblog && microblog.length > 0
                    && microblog.map((item, index) => {
                        return <ContactItem
                            key={index}
                            contactIcon={iconWeibo}
                            contactName={item.name}
                            nameColor="web-url"
                            nameClickCallback={() => {jump(item.link, 'microblog', item.name);}}
                        />;
                    })
                }
            </div>
        </div>}
    </div>);
}